module.exports = __webpack_public_path__ + "img/ch74.03282830.png";